import useAccountQuery from "./useAccountQuery";
import useIsRole from "./useIsRole";

// use for Appsmen Admin and Branch Admin ( owner )

const useIsKioskUser = (customRoles?: string[]) => {
  const { data: account } = useAccountQuery();
  const isKiosk = useIsRole(account?.roles, ["ROLE_KIOSK"]);
  return isKiosk;
};

export default useIsKioskUser;
